export default "__VITE_ASSET__Cyzt7zLb__"